import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  EditButton,
  SimulateButton,
} from '../Common/DataTable/tableActionButtons';

const ActiveBadge = ({ value }) => {
  const { t } = useTranslation();
  return (
    <span className={`badge badge-${value ? 'success' : 'secondary'}`}>
      {t(value ? 'Yes' : 'No')}
    </span>
  );
};

const createTableColumns = (openEditModal, openSimulator) => {
  return [
    {
      title: 'ID',
      name: 'id',
      hidden: true,
    },
    {
      title: 'Name',
      width: 220,
      name: 'name',
      sort: true,
    },
    {
      title: 'Channel',
      width: 110,
      name: 'channel',
      sort: true,
    },
    {
      title: 'Fields',
      width: 90,
      name: 'collectFieldsCount',
      align: 'center',
    },
    {
      title: 'Handoff (min)',
      width: 120,
      name: 'handoffWindowMinutes',
      align: 'center',
      sort: true,
    },
    {
      title: 'Active',
      width: 90,
      name: 'active',
      align: 'center',
      formatterComponent: ActiveBadge,
    },
    {
      title: 'Objective',
      name: 'objective',
    },
    {
      title: 'Action',
      name: 'action',
      width: 120,
      align: 'center',
      isDummyField: true,
      formatterComponent: ({ row }) => (
        <ul className="list-inline font-size-20 contact-links mb-0">
          <EditButton row={row} onPress={openEditModal} />
          <SimulateButton
            row={row}
            onPress={openSimulator}
            disabled={row.channel !== 'whatsapp'}
            disabledReason="Only WhatsApp agents can be simulated"
          />
        </ul>
      ),
    },
  ];
};

export default createTableColumns;
